/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    NEW_INVOICE: 'Nueva factura'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Error al enviar la acumulación',
    CANCEL_ACCUMULATION: 'Error al cancelar la acumulación',
    CANCEL_INVOICE: 'Error al cancelar la factura',
    COUPON_CANCELED: 'Error al cancelar el cupón',
    COUPON_GENERATED: 'Error al crear el cupón',
    ERROR: 'Error',
    INVOICE_SUBMITTED: 'Error al enviar la factura'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Remuneración acum.',
    ATTACHMENT: 'Archivos adjuntos',
    CHALLENGE: 'Desafío',
    COUPON: 'Cupón',
    COUPON_CODE: 'Código de cupón',
    DECISION: 'Decisión',
    MONTH: 'Mes',
    OBSERVATIONS: 'Observaciones',
    REMUNERATION: 'Remuneración',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Fecha de envío'
  },
  LABEL: {
    ACCUMULATE: 'Acumular',
    ACCUMULATED: 'Acumulada',
    ACTIVES: 'Activas',
    ALL: 'Todas',
    BEGIN_DATE: 'Fecha de inicio',
    CANCEL: 'Cancelar',
    CANCEL_ACCUMULATION: 'Cancelar acumulación',
    CANCEL_COUPON: 'Cancelar cupón',
    CANCEL_INVOICE: 'Cancelar factura',
    CLOSE: 'Cerrar',
    CODE: 'Código',
    CONFIRM: 'Confirmar',
    CONFIRM_ACCUMULATE: 'Acumular',
    CONFIRM_COUPON_CREATION: 'Generar cupón',
    CONFIRM_SUBMIT_INVOICE: 'Enviar',
    COPY_COUPON_CODE: 'Copiar código de cupón',
    COUPON: 'Cupón',
    COUPON_CODE: 'Código de cupón',
    CURRENT_PERIOD: 'Período actual',
    DATE: 'Fecha',
    DESCRIPTION: 'Descripción',
    END_DATE: 'Fecha de finalización',
    FILTER: 'Filtro',
    GENERATE_COUPON: 'Generar cupón',
    GO_TO_DETAILS: 'Detalles',
    INVOICE: 'Factura',
    MODEL: 'Modelo',
    MONEY: 'Dinero',
    MONTH: 'Mes',
    NEW_INVOICE: 'Nueva factura',
    PAYMENT_METHOD: 'Método de pago',
    PENDING_COUNTERPARTS: 'Contraprestaciones pendientes',
    PENDING_COUNTERPARTS_MODAL_TITLE: 'Contraprestaciones pendientes',
    PENDING_VALUE: 'Importe pendiente',
    PREVIOUS_PERIOD: 'Período anterior',
    REMUNERATION: 'Remuneración',
    SELECTED_PRODUCTS: 'Productos seleccionados',
    STATE: 'Estado',
    SUBMIT_INVOICE_ATTACHMENT: 'Archivos adjuntos (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Comentarios',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Importe',
    WITHOUT_PRODUCTS: 'Sin productos seleccionados',
    YEAR: 'Año'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: '¿Realmente deseas cancelar la acumulación?',
    CANCEL_COUPON: '¿Realmente deseas cancelar el cupón {value}?',
    CANCEL_INVOICE: '¿Realmente deseas cancelar el envío de la factura?',
    CANT_GENERATE_COUPON: 'No puedes generar este cupón.',
    CANT_SUBMIT_REMUNERATION: 'No puedes enviar esta factura.',
    CONFIRM_SUBMIT_COUPON:
      'Vas a generar un cupón de {couponValue}. ¿Quieres continuar?',
    EMPTY_TITLE: 'No hay datos'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Remuneración acumulada',
    CANCEL_ACCUMULATION: 'Acumulación cancelada',
    CANCEL_INVOICE: 'Factura cancelada',
    COUPON_CANCELED: 'Cupón cancelado',
    COUPON_COPIED: 'Cupón copiado al portapapeles',
    COUPON_GENERATED: 'Cupón creado con el código %{value}',
    INVOICE_SUBMITTED: 'Enviar factura',
    SUCCESS: 'Acción realizada correctamente'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Remuneración acumulada',
    ATTACHMENT: 'Archivos adjuntos',
    CHALLENGE: 'Desafío',
    COUPON: 'Cupón',
    COUPON_CODE: 'Código de cupón',
    DECISION: 'Decisión',
    MONTH: 'Mes',
    OBSERVATIONS: 'Observaciones',
    REMUNERATION: 'Remuneración',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Fecha de envío',
    SWIPE: 'Desliza a la izquierda para ver más columnas.',
    VIEW_CHALLENGE_DETAILS: 'Ver detalles del desafío'
  }
};
